/** @format */

import moment from 'moment';

export const utilityGetVisitURL = ({ roomCode, formatMessage }: { roomCode: string; formatMessage: Function }) => {
  const params = [];
  if (roomCode) params.push(`roomCode=${encodeURIComponent(roomCode.toUpperCase())}`);
  return [`/${formatMessage({ id: 'url_part_request_visit' })}/`, params.join('&')].join('?');
};
